import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

// connect 時に自身(モーダル要素)を BS5 Modal として開く。
// 旧 inline jQuery `$('#modalLiasTutorial').modal()` を Stimulus 化したもの。
// 出し分け(初回のみ表示等)はサーバ側で data-controller の有無を制御する。
// 先例: permission_approval_modal_controller。
export default class extends Controller {
  connect() {
    this.modal = Modal.getOrCreateInstance(this.element);
    this.modal.show();
  }

  disconnect() {
    if (this.modal) this.modal.dispose();
  }
}
